const o=(o,e)=>Boolean(o&&e);export{o as isNeedToBoldTitle};
